<template>
  <div class="relative z-1">
    <saving-overlay
      :label="i18n.saving"
      v-if="saving"
      class="rounded-r rounded-bl"
    ></saving-overlay>
    <form @submit.prevent="save" class="p-5">
      <div class="flex">
        <div class="pr-1 flex-1">
          <simple-radio
            :label="i18n.language.label"
            :label-info="i18n.language.info"
            v-model="form.language"
            name="genre"
            :initial-value="preferences.language"
            :required="true"
            :options="[
              {
                id: 'en',
                label: i18n.language.english,
              },
              {
                id: 'fr',
                label: i18n.language.french,
              },
            ]"
          ></simple-radio>

          <simple-select
            :label="i18n.usual_software"
            v-model="form.usual_software"
            name="usual_software"
            :required="true"
            :options="applications"
            v-if="applications !== undefined"
            class=""
          ></simple-select>

          <simple-radio
            :label="i18n.image_kind.label"
            v-model="form.image_kind"
            name="image_kind"
            :initial-value="preferences.image_kind"
            :required="true"
            :options="[
              {
                id: 'still',
                label: i18n.image_kind.still,
              },
              {
                id: 'animation',
                label: i18n.image_kind.animation,
              },
              {
                id: 'both',
                label: i18n.image_kind.both,
              },
            ]"
          ></simple-radio>

          <simple-label
            id="newsletter"
            :label="i18n.newsletter.label"
            label-info=""
            :required="false"
            class="border-b border-gray-100 mb-2"
          ></simple-label>
          <simple-checkbox
            :label="i18n.newsletter.receive_newsletter"
            v-model="form.receive_newsletter"
            name="receive_newsletter"
            :with-error-message="false"
          ></simple-checkbox>
          <simple-checkbox
            :label="i18n.newsletter.receive_promotion"
            v-model="form.receive_promotion"
            name="receive_promotion"
            :with-error-message="false"
          ></simple-checkbox>
        </div>
      </div>
      <div class="flex items-center justify-end">
        <ranch-button
          type="submit"
          :label="i18n.save"
          icon="save"
        ></ranch-button>
      </div>
    </form>
  </div>
</template>

<script>
import { flash, handleAxiosError } from "@/boot/functions";

import { Form } from "../../../Utilities/Form";
import { mapState } from "vuex";
import SimpleSelect from "../../../Design/Forms/SimpleSelect";
import SimpleRadio from "../../../Design/Forms/SimpleRadio";
import SavingOverlay from "../../../Design/Forms/SavingOverlay";
import SimpleCheckbox from "../../../Design/Forms/SimpleCheckbox";
import SimpleLabel from "../../../Design/Forms/SimpleLabel";

export default {
  props: ["preferences"],
  components: {
    SimpleSelect,
    SimpleRadio,
    SavingOverlay,
    SimpleCheckbox,
    SimpleLabel,
  },
  mixins: [],
  data: function () {
    return {
      saving: false,
      saved: false,
      form: new Form({
        language: this.preferences.language,
        image_kind: this.preferences.image_kind,
        usual_software: this.preferences.usual_software,
        receive_newsletter: this.preferences.receive_newsletter,
        receive_promotion: this.preferences.receive_promotion,
      }),
    };
  },
  methods: {
    save() {
      this.saving = true;
      this.form
        .post(this.endpoint)
        .then((data) => {
          this.$store.commit("account/setPreferences", data.data);
          this.saving = false;
          this.saved = true;
          flash(this.i18n.saved, "success");
        })
        .catch(handleAxiosError)
        .then(() => {
          this.saving = false;
        });
    },
  },
  computed: {
    ...mapState({
      i18n: (state) => state.account.i18n.settings.preferences.form,
      applications: (state) =>
        Object.entries(state.app.applications).map(([id, label]) => ({
          id,
          label,
        })),
    }),
    endpoint() {
      return this.$store.state.account.routes.preferences;
    },
  },
  mounted() {},
};
</script>

<style></style>
